import Lottie from "lottie-react"
import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import { StructuredText } from "react-datocms"

import animation from "../../../static/chatCommerceSwitchbackLottie.json"
import {
  ChatCommerceContainer,
  Wrapper,
} from "../../styles/Components/SingleInstance/ChatCommerce"
import Heading from "../../utils/OptimizedHeading"

const ChatCommerce = ({ component, grid }) => {
  const bgClass = component?.background?.replace(/ /g, "").toLowerCase()

  return (
    <ChatCommerceContainer
      className={`bg-${bgClass} container-${
        grid !== "" ? grid?.toLowerCase() : "normal"
      }`}
    >
      <Wrapper>
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col xl={10}>
              <div className="heading-container mb-4">
                {component?.eyebrow && (
                  <p className="heading-kicker eyebrow">{component?.eyebrow}</p>
                )}
                {component?.heading && (
                  <Heading
                    type={component?.headingSize}
                    string={component?.heading}
                    className="heading"
                  />
                )}
              </div>
            </Col>
          </Row>
          <Row className="content-row">
            <Col xl={8}>
              <div>
                <Lottie animationData={animation} loop autoplay />
              </div>
            </Col>
            <Col xl={4}>
              {component?.singleinsBody && (
                <div className="description">
                  <StructuredText data={component?.singleinsBody} />
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </Wrapper>
    </ChatCommerceContainer>
  )
}

export default ChatCommerce
